import React, { useState, useCallback } from 'react';
import VideoPlayer from '../components/VideoPlayer';
import { 
  brandBlue, 
  textDark, 
  background, 
  border, 
  container,
  heroPadding
} from '../styles/theme';

const isFirefox = typeof navigator !== 'undefined' && /firefox/i.test(navigator.userAgent);

function LiveAutocaptioning() {
  const [selectedStream, setSelectedStream] = useState('stream1');

  const streamOptions = {
    stream1: {
      name: 'Live News Stream',
      url: 'https://d159lytztryht0.cloudfront.net/out/v1/mpv2-cmaf-transcribe-ChannelGroup/mpv2-cmaf-transcribe/mpv2-cmaf-transcribe-hls/mpv2-cmaf-transcribe.m3u8',
      description: 'Live news broadcast with real-time captioning'
    }
  };

  const handleCueChange = useCallback((textTrack) => {
    [...textTrack.cues].forEach((cue) => {
      cue.line = 75
      cue.position = isFirefox ? 5 : 30
      // x.align = "center"
      });
  }, []);

  return (
    <div className="min-h-screen bg-white" style={{ color: textDark }}>
      {/* Hero */}
      <section className={`mx-auto ${container} px-6 ${heroPadding}`}>
        <img src="https://www.bigbluemarble.com/img/marble.svg" alt="" aria-hidden="true" role="presentation" className="pointer-events-none select-none absolute inset-0 -z-10 opacity-10 object-cover" />
        <div className="grid md:grid-cols-12 gap-8 items-center">
          <div className="md:col-span-7">
            <h1 className="text-3xl md:text-5xl font-bold leading-tight" style={{ color: brandBlue }}>
              Automatic Live Captioning
              <span className="block text-lg md:text-2xl mt-3 font-normal" style={{ color: textDark, opacity: 0.85 }}>MediaServices-powered live captioning with translation.</span>
            </h1>
            <p className="mt-4 max-w-2xl" style={{ opacity: 0.9 }}>
              Leverage AWS MediaServices for real-time speech-to-text processing with live translation capabilities. Get instant, accurate captions for live content using advanced AI models, support multiple languages and ensure accessibility compliance for live broadcasts and streaming events.
            </p>
            <div className="mt-6 flex flex-wrap gap-3 text-xs">
              {['Real-time Processing','Multi-language Support','High Accuracy','MediaServices Integration'].map((t,i)=> (
                <span key={i} className="rounded-full px-3 py-1 border" style={{ borderColor: brandBlue, color: brandBlue }}>
                  {t}
                </span>
              ))}
            </div>
          </div>
          <div className="md:col-span-5">
            <div className="relative rounded-2xl overflow-hidden shadow-lg" style={{ border: `1px solid ${border}` }}>
              <div className="aspect-video">
                <img src="/images/LiveAutoCap_poster.png" alt="Video Upscaling Poster" className="h-full w-full object-contain" />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Demo Section */}
      <div className="py-16 px-4">
        <div className="max-w-6xl mx-auto">
          <div className="grid grid-cols-12 gap-8 items-start">
            {/* Column 1: Stream Controls */}
            <div className="col-span-4">
              <div className="rounded-2xl overflow-hidden shadow-lg h-fit" style={{ border: `1px solid ${border}` }}>
                <div className="p-4" style={{ background: background, borderBottom: `1px solid ${border}` }}>
                  <h3 className="font-semibold" style={{ color: brandBlue }}>Caption Configuration</h3>
                </div>
                <div className="p-6 space-y-6">
                  {/* Stream Selection */}
                  <div>
                    <label className="block text-sm font-medium mb-2" style={{ color: textDark }}>
                      Live Stream Source
                    </label>
                    <select 
                      value={selectedStream}
                      onChange={(e) => setSelectedStream(e.target.value)}
                      className="w-full p-3 rounded-lg border focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                      style={{ borderColor: border }}
                    >
                      {Object.entries(streamOptions).map(([key, stream]) => (
                        <option key={key} value={key}>
                          {stream.name}
                        </option>
                      ))}
                    </select>
                    <p className="text-sm mt-2" style={{ opacity: 0.7 }}>
                      {streamOptions[selectedStream].description}
                    </p>
                  </div>
                </div>
              </div>
            </div>

            {/* Column 2: Live Stream with Captions */}
            <div className="col-span-8">
              <div className="rounded-2xl overflow-hidden shadow-lg h-fit" style={{ border: `1px solid ${border}` }}>
                <div className="p-4" style={{ background: background, borderBottom: `1px solid ${border}` }}>
                  <h3 className="font-semibold" style={{ color: brandBlue }}>
                    Live Stream with Auto-Generated Captions
                  </h3>
                  <p className="text-sm mt-1" style={{ opacity: 0.8 }}>
                    {streamOptions[selectedStream].name}
                  </p>
                </div>
                <div className="p-6">
                  <VideoPlayer 
                    src={streamOptions[selectedStream].url}
                    autoPlay={true}
                    videoClassName="video-autotitles w-full h-auto object-contain"
                    onCueChange={handleCueChange}
                  />      
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default LiveAutocaptioning;
